<template>
    <div class="pre-flight-reporting-main">
        <div class="title is-size-5 ">Pre-flight Inspection</div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Inspection Time</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <p class="control is-expanded">
                            <datepicker
                                    :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.BTO.inspectionTime" v-model="InputsObject.BTO.inspectionTime" disabled/>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Done By</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input class="input" required="required" type="text" placeholder="TLC" v-if="InputsObject.BTO.doneBy" v-model="InputsObject.BTO.doneBy" readonly>
                    </div>
                </div>
            </div>
        </div>
        <div class="title is-size-5 ">Planned Fuel</div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Block Fuel Including Taxi (Kg)</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input class="input" type="text" :value="BlockFuel" readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="title is-size-5">Retrieve Fuel on Blocks From Previous Flight</div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Landing Fuel from Previous Flight *</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input class="input is-danger" type="text" placeholder="Kg" v-if="InputsObject.BTO.landingFuelFromPreviousFlight" v-model="InputsObject.BTO.landingFuelFromPreviousFlight" required readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Actual Block Fuel Including Taxi (Kg) *</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input v-if="InputsObject.BTO.actualBlockFuelIncludingTaxi" v-model="InputsObject.BTO.actualBlockFuelIncludingTaxi" class="input is-danger" type="text" placeholder="Kg" required readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Reason for deviation from Planned Block Fuel</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input class="input is-danger" type="text" placeholder="" v-if="InputsObject.BTO.reasonOfDifference" v-model="InputsObject.BTO.reasonOfDifference"  readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Density *</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input class="input is-danger" v-if="InputsObject.BTO.density" v-model="InputsObject.BTO.density" type="text" placeholder="Kg/L" readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Actual Fuel Uplift (L) *</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input class="input is-danger" type="text" placeholder="L" v-if="InputsObject.BTO.actualFuelUplift" v-model="InputsObject.BTO.actualFuelUplift" readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Planned Fuel Uplift(L)</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input class="input" type="text" placeholder="L"  v-if="InputsObject.BTO.actualFuelUplift" v-model="InputsObject.BTO.actualFuelUplift" disabled readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Delta(L)</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input class="input" type="text" placeholder="L" v-if="InputsObject.BTO.delta" v-model="InputsObject.BTO.delta" disabled readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label">
                <label class="label">Fuel Slip Number 1</label>
            </div>
            <div class="field-body">
                <div class="field is-expanded">
                    <div class="field has-addons">
                        <p class="control is-expanded">
                            <input class="input" type="tel" v-if="InputsObject.BTO.fuelSlipNumber1" v-model="InputsObject.BTO.fuelSlipNumber1" readonly>
                        </p>
                        <p class="control">
                            <a class="button is-static">
                            #
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>


        <br/>
        <div class="field"><p class="heading is-size-6 has-text-centered"><b>Slip Photo 1 (Capture in Portralt mode)</b></p>
        </div>

        <div class="field is-horizontal">

            <div class="field-label is-normal">
                <label class="label"></label>
            </div>

            <div class="content">
                <img :src="getJpgFuelSlip1" @error="errorFuelSlip(0)" @load="errorFuelSlip(1)" onerror="this.style.display='none'" width="100%" height="100%" alt="Fuel Slip Photo 1">
            </div>
            <div v-if="!fuelSlipshow">
                <p>Fuel slip photo couldn't get.</p>
            </div>

        </div>



        <div class="field is-horizontal">

            <div class="field-label">
                <label class="label">Fuel Slip Number 2</label>
            </div>

            <div class="field-body">
                <div class="field is-expanded">
                    <div class="field has-addons">
                        <p class="control is-expanded">
                            <input class="input" type="tel" v-if="InputsObject.BTO.fuelSlipNumber2" v-model="InputsObject.BTO.fuelSlipNumber2" readonly>
                        </p>
                        <p class="control">
                            <a class="button is-static">
                                #
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>


        <br/>
        <div class="field"><p class="heading is-size-6 has-text-centered"><b>Slip Photo 2 (Capture in Portralt mode)</b></p></div>

        <div class="field is-horizontal">

            <div class="field-label is-normal">
                <label class="label"></label>
            </div>

            <div class="content">
                    <img :src="getJpgFuelSlip2" @error="errorFuelSlip2(0)" @load="errorFuelSlip2(1)"  onerror="this.style.display='none'" width="100%" height="100%" alt="Fuel Slip Photo 2">
            </div>
            <div v-if="!fuelSlip2show">
                <p>Fuel slip photo 2 couldn't get.</p>
            </div>

        </div>

        <br/>

        <div class="field"><p class="heading is-size-6 has-text-centered"><b>Authority and Security Inspections 1 (Capture in Portra)</b></p></div>
        <div  class="content">
            <img :src="getJpgAuthSecInsp1" @error="errorAuthSecInsp1(0)" @load="errorAuthSecInsp1(1)" onerror="this.style.display='none'"  width="100%" height="100%" alt="AuthSecInsp1">
        </div>
        <div v-if="!AuthSecInsp1jpegshow">
            <p>Authority and Security Inspections 1 photo couldn't get.</p>
        </div>

        <br/>

        <div class="field"><p class="heading is-size-6 has-text-centered"><b>Authority and Security Inspections 2 (Capture in Portra)</b></p></div>
        <div class="content">
            <img :src="getJpgAuthSecInsp2" @error="errorAuthSecInsp2(0)" @load="errorAuthSecInsp2(1)" onerror="this.style.display='none'" width="100%" height="100%" alt="AuthSecInsp2">
        </div>
        <div v-if="!AuthSecInsp2jpegshow">
            <p>Authority and Security Inspections 2 photo couldn't get.</p>
        </div>

        </div>
</template>

<script>
    import {/*mapActions,*/ mapState} from "vuex";
    import {loadingMixin} from "../../../utils/mixins";
    import {createUrl} from "../../../http";

    import Datepicker from 'vue-bulma-datepicker'
    // import vueFilePond from 'vue-filepond';
    // import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
    // import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';
    // import 'filepond/dist/filepond.min.css';
    // import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
    // const  FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

    export default
    {
        name: "PreFlightReporting",
        props: ["id", "flight"],
        mixins: [loadingMixin],

        data() {
            return {

                blockfuel : "",
                Jpegshow : true,
                fuelSlipshow: true,
                fuelSlip2show: true,
                AuthSecInsp1jpegshow:true,
                AuthSecInsp2jpegshow:true,
                activeJpegUrl : createUrl('/EffIpadPreview/GetInputJpeg/'),

                getJpgFuelSlip1 :"",
                getJpgFuelSlip2 :"",
                getJpgAuthSecInsp1 : "",
                getJpgAuthSecInsp2 : "",

            }
        },

        components: {
            // FilePond,
            Datepicker,
        },

        computed : {

            ...mapState("ipadmain",[ "ActiveDevice_UID","selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","OCCSelfVersions_VS_IPADLastKnownVersions","LastInputsJson","InputsObject"]),

            BlockFuel:function(){
                return this.EFF_Json_Data.poFuel.BlockFuelEstimatedWeightKg;
            },

        },

        created()
        {

            // this.getJpegStreamUrl = this.activeJpegUrl + this.id + "/" + this.flight.std + "/" + "BTO_AtisDep.jpg";
            try {
                this.getJpgFuelSlip1 = this.activeJpegUrl + this.id + "/" + this.flight.std + "/" +this.ActiveDevice_UID+"/" + "BTO_FuelSlipPhoto1.jpg"+"/"+this.flight.flightArchiveStat;
                this.getJpgFuelSlip2 = this.activeJpegUrl + this.id + "/" + this.flight.std + "/" +this.ActiveDevice_UID+"/" + "BTO_FuelSlipPhoto2.jpg"+"/"+this.flight.flightArchiveStat;
                this.getJpgAuthSecInsp1 = this.activeJpegUrl + this.id + "/" + this.flight.std + "/"+ this.ActiveDevice_UID +"/" + "BTO_AuthSecInspections1.jpg"+"/"+this.flight.flightArchiveStat;
                this.getJpgAuthSecInsp2 = this.activeJpegUrl + this.id + "/" + this.flight.std + "/" + this.ActiveDevice_UID +"/" + "BTO_AuthSecInspections2.jpg"+"/"+this.flight.flightArchiveStat;

            }
             catch (e) {
                 this.$notify({title: "Warning", text:"Error on created area " +  e.message, type: "warning"});
             }
        },

        methods: {

            errorFuelSlip(stat)
            {
                if (stat ==0)
                {
                    this.fuelSlipshow = false;
                }
                else if(stat ==1)
                {
                    this.fuelSlipshow = true;
                }
            },

            errorFuelSlip2(stat)
            {
                if (stat ==0)
                {
                    this.fuelSlip2show = false;
                }
                else if(stat ==1)
                {
                    this.fuelSlip2show = true;
                }
            },

            errorAuthSecInsp1(stat)
            {
                if (stat ==0)
                {
                    this.AuthSecInsp1jpegshow = false;
                }
                else if(stat ==1)
                {
                    this.AuthSecInsp1jpegshow = true;
                }
            },

            errorAuthSecInsp2(stat)
            {
                if (stat ==0)
                {
                    this.AuthSecInsp2jpegshow = false;
                }
                else if(stat ==1)
                {
                    this.AuthSecInsp2jpegshow = true;
                }
            },
        }
    }
</script>

<style scoped>
    .filepond--drop-label {
        background-color: black;
        color: #FFFFFF;
    }

    .title {
        padding: 10px;
        background-color: #b5b5b53d;
    }

    label {
        width: 300px;
        height: 35px;
        max-resolution: res;
        margin: inherit;
        margin-top: -2px;
        padding-right: 10px;
        margin-left: 10px;
        text-align: -webkit-left;
    }

</style>
